module.exports = __webpack_public_path__ + "img/芒果8.b9e384e9.png";